import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { VarificationService } from 'src/app/services/core/varifications/varification.service';

@Component({
  selector: 'app-driver-verification-slideout',
  templateUrl: './driver-verification-slideout.component.html',
  styleUrls: ['./driver-verification-slideout.component.css']
})
export class DriverVerificationSlideoutComponent implements OnInit {
  submitted = false;
  driverFrom!: FormGroup;
  driverVarificationForm!: FormGroup
  @Input() driverDetail: any;
  @Output() closeModal = new EventEmitter<any>
  driverId: any;

  constructor(
    private varificationSerice: VarificationService,
    private cedentialService: CredentialService,
    private fb: FormBuilder) { }

  ngOnInit() {

    this.driverId = this.driverDetail.id;

    this.driverFrom = this.fb.group({
      firstName: ['',],
      lastName: [''],
      address: this.fb.group({
        name: [''],
        coords: [''],
        city: [''],
        state: [''],
      }),
      phoneNumber: [''],
      contactNumber: [''],
      email: [''],
      profileImageURL: [''],
      dob: [''],
      languageSpoken: [''],

      driverLicense: this.fb.group({
        image: ['',],
        number: [''],
        issueDate: ['',],
        expireDate: ['',],
        stateIssue: [''],
      }),
      examinations: this.fb.group({
        phyExamImage: [''],
        phyExamDate: [''],
        drugTestImage: [''],
        drugTestDate: ['',],
      }),
      abuse: [false],
      violations: [false],
      serviceAreas: [[],],
    })

    this.driverVarificationForm = this.fb.group({
      isFirstName: [false],
      isLastName: [false],
      isProfileImageURL: [false],
      isPhoneNumber: [false],
      isContactNumber: [false],
      isEmail: [false],
      isDob: [false],
      isLanguageSpoken: [false],
      address: this.fb.group({
        isName: [false],
        isCity: [false],
        isState: [false],
      }),
      driverLicense: this.fb.group({
        isImage: [false],
        isNumber: [false],
        isIssueDate: [false],
        isExpireDate: [false],
        isStateIssue: [false],
      }),
      examinations: this.fb.group({
        isPhyExamImage: [false],
        isPhyExamDate: [false],
        isDrugTestImage: [false],
        isDrugTestDate: [false],
      }),
      isAbuse: [false],
      isViolations: [false],
      isServiceAreas: [false],
    });

    this.getDriverById();

  }

  getDriverById() {

    this.cedentialService.getDriverById(this.driverId).subscribe((data:any) => {

      if (data) {

        this.driverFrom.patchValue({
          ...this.driverDetail
        })

        if(data.validationFlags){
          this.driverVarificationForm.patchValue({
          ...data.validationFlags
        })
        }
      }
    })
  }

  // setControlValue(groupName: string, controlName: string, value: boolean) {
  //   const fullPath = groupName ? `${groupName}.${controlName}` : controlName;
  //   const control = this.driverVarificationForm.get(fullPath);
  //   if (control) {
  //     control.setValue(value);
  //     control.markAsTouched();
  //   }
  // }



  onCloseModal() {
    this.closeModal.emit();
  }

  onSave() {
    this.submitted = true
    if (this.driverVarificationForm.invalid) {
      return;
    }
    const payload = this.driverVarificationForm.value;
    this.varificationSerice.verifyDriver(this.driverId, payload).subscribe((data) => {
      if (data) {
        console.log('data', data);
      }
    })


  }

  setControl(control: AbstractControl, value: any): void {
    if (control) {
      control.setValue(value);
    }
  }

  // Getter for form controls
  get form(): any {
    return this.driverVarificationForm.controls;
  }
  get address(): any {
    return this.driverVarificationForm.get('address') as FormGroup;
  }

  get driverLicense(): any {
    return this.driverVarificationForm.get('driverLicense') as FormGroup;
  }

  get examinations(): any {
    return this.driverVarificationForm.get('examinations') as FormGroup;
  }
}
